import { backendFetch } from './apiUtils';

export const getCommodityCodeTree = async (commodityCode) => {
  return await backendFetch({
    url: 'newload/commodityTree',
    params: {
      commCode: commodityCode,
    },
  });
};

export const updateLoadStatus = async (loadId, status) => {
  return await backendFetch({
    url: `newload/updateStatus/${loadId}`,
    method: 'PUT',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status }),
    },
  });
};

// returns heading descriptions for commodity codes
export const getCommodityDescriptions = async (items) => {
  return await backendFetch({
    url: 'newload/commodityDescriptions',
    method: 'POST',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    },
  });
};

// returns heading descriptions for commodity codes
export const getQAPreferenceDetails = async (newLoadId) => {
  return await backendFetch({
    url: 'newload/qaPreferences',
    method: 'GET',
    params: { newLoadId },
  });
};

// download CABIE export file for a load (specify origin and hscode to get file for IPAFFs)
export const downloadCABIEFile = async ({ loadId, fileName, origin, hsCodes = [] }) => {
  const data = await backendFetch({
    url: `newload/downloadFile`,
    method: 'GET',
    params: { id: loadId, origin, hscode: hsCodes.join(',') },
  });

  const isIpaffsExport = Boolean(origin && hsCodes.length > 0);
  const exportData = isIpaffsExport ? (({ customer, parent, ...rest }) => rest)(data) : data;

  downloadJsonFile({ data: exportData, fileName });
};

export const downloadJsonFile = ({ data, fileName = 'cabieFile' }) => {
  const fileNameWithExtension = `${fileName}.json`;
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileNameWithExtension;
  a.click();
  URL.revokeObjectURL(url);
};

export const getCompanyNameFromId = async (companyId, parentId = '') => {
  return await backendFetch({
    url: 'newload/companyNameFromId',
    method: 'GET',
    params: { companyId, parentId },
  });
};

export const postCheckPreferentialValidation = async (items) => {
  const body = typeof items === 'string' ? items : JSON.stringify(items);
  return backendFetch({
    url: 'newload/qaPrefValidation',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body,
    },
  });
};

export const postRexValidation = async (items) => {
  return backendFetch({
    url: 'newload/validateRex',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    },
  });
};
